import { useAppSelector } from "@/redux/hooks";
import { AddCircleOutlineIcon } from "@brandclub/common-ui";
import { ButtonBase } from "@mui/material";
import {
  LineItem,
  PaymentMethod,
  ShippingRate,
  StripeExpressCheckoutElementShippingAddressChangeEvent,
  StripeExpressCheckoutElementShippingRateChangeEvent,
} from "@stripe/stripe-js";
import {
  StripeCardCheckout,
  StripeExpressCheckout,
} from "../../../../../../Stripe";

import { ResponsiveDialog } from "@/components/StoreComponents/StoreDialogs/ResponsiveDialog";
import { useState } from "react";

export const StripePaymentForm = ({
  onSuccess,
  onError,
  onShippingAddressChange,
  onShippingRateChange,
  shippingRates,
  lineItems,
}: {
  onCancel: () => void;
  onSuccess: (
    paymentMethodType: "express" | "card",
    paymentMethod: PaymentMethod
  ) => void;
  onError: (error: Error) => void;
  onShippingAddressChange: (
    event: StripeExpressCheckoutElementShippingAddressChangeEvent
  ) => void;
  onShippingRateChange: (
    event: StripeExpressCheckoutElementShippingRateChangeEvent
  ) => void;
  shippingRates: ShippingRate[];
  lineItems: LineItem[];
}) => {
  const user = useAppSelector((state) => state.userProfile);
  const [openPaymentMethodDrawer, setOpenPaymentMethodDrawer] = useState(false);

  if (!user) {
    return null;
  }

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
            color: "#666",
            fontWeight: 500,
            marginBottom: "16px",
          }}
        >
          Express checkout
        </div>
        <StripeExpressCheckout
          onSuccess={(paymentMethod) => onSuccess("express", paymentMethod)}
          onError={onError}
          onShippingAddressChange={onShippingAddressChange}
          onShippingRateChange={onShippingRateChange}
          shippingRates={shippingRates}
          lineItems={lineItems}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "20px 0",
          color: "#666",
        }}
      >
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#dcdddc",
          }}
        />
        <span
          style={{
            margin: "0 16px",
            fontSize: "14px",
          }}
        >
          OR
        </span>
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#dcdddc",
          }}
        />
      </div>
      <ButtonBase
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontWeight: 500,
          width: "100%",
        }}
        onClick={() => {
          setOpenPaymentMethodDrawer(true);
        }}
      >
        <AddCircleOutlineIcon className="add_new_icon" />
        Add a credit card
      </ButtonBase>

      <ResponsiveDialog
        open={openPaymentMethodDrawer}
        onClose={() => setOpenPaymentMethodDrawer(false)}
      >
        <StripeCardCheckout
          onSuccess={(paymentMethod) => onSuccess("card", paymentMethod)}
          onError={onError}
          onShippingAddressChange={onShippingAddressChange}
          onShippingRateChange={onShippingRateChange}
          shippingRates={shippingRates}
          onCancel={() => {
            setOpenPaymentMethodDrawer(false);
          }}
        />
      </ResponsiveDialog>
    </>
  );
};
